/**
 * Core Layer - Main Barrel Export
 * Framework-agnostic utilities, types, and clients
 * This layer has NO dependencies on React, Next.js, or any framework
 */

// Config
export * from "./config";

// Errors
export * from "./errors";

// Types
export * from "./types";

// Utils
export * from "./utils";

// Routes
export * from "./routes";

// Clients
export * from "./clients";

// Validations
export * from "./validations";
